export const getLayouts = (theme, isHorizontal) => {
    var _a;
    return ({
        'default': {
            decimals: 2,
            height: 500,
            hideXAxisLabels: true,
            showAnimation: false
        },
        'waterfall': {
            decimals: 2,
            height: 500,
            hideXAxisLabels: true,
            isWaterfallHorizontal: isHorizontal
        },
        'label_y_axis': {
            decimals: 2,
            height: 500,
            marginTop: 0,
            hideXAxisLabels: true,
            isPercentToggle: false,
            isWaterfallHorizontal: true,
            useValueInYAxis: true,
            disableIsMobile: true,
            disableCursor: true,
            colors: (_a = theme.barColors) !== null && _a !== void 0 ? _a : theme.chartColors
        }
    });
};
